import React from 'react';

import { useCurrentUser } from '@klp/auth';
import { Block } from '@klp/design/Block';
import { useGetLeverandorProcessStatisticsQuery } from '@klp/leverandor/services';
import { portfolioSelectors } from '@klp/portfolio/store';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import { LocalLoader } from '@klp/design/Loader';
import LeverandorSummaryStatistics from './LeverandorSummaryStatistics';
import { LeverandorRoutes } from '@klp/leverandor/config';
import { Link } from '@klp/design';

const useStyles = makeStyles(() => ({
    title: {
        textTransform: 'uppercase',
    },
}));

export default function LeverandorSummaryView() {
    const classes = useStyles();
    const { currentUser, isEDAdmin } = useCurrentUser();
    const { portfolio } = useSelector(portfolioSelectors);
    const {
        data: leverandorStatistics,
        isLoading,
        isFetching,
    } = useGetLeverandorProcessStatisticsQuery(
        {
            ansvarlig: isEDAdmin ? portfolio?.brukerId : currentUser?.epost,
            region: currentUser?.region,
        },
        { skip: false },
    );

    return (
        <>
            <Block
                marginTop="compact"
                display="inline"
                klpTypographyVariant="xsmall"
                className={classes.title}
                translation="frontPage.leverandor.subtitle"
            />
            <LocalLoader
                isLoading={isLoading || isFetching}
                data-testid="Loader"
            >
                {leverandorStatistics && (
                    <LeverandorSummaryStatistics
                        statistics={leverandorStatistics}
                    />
                )}
            </LocalLoader>
            <Block paddingTop="compact">
                <Link
                    href={LeverandorRoutes.leverandorSchema()}
                    translation="frontPage.leverandor.actionButtonText"
                />
            </Block>
        </>
    );
}
